import { render, staticRenderFns } from "./Quota.vue?vue&type=template&id=34f98cb2&scoped=true&"
import script from "./Quota.vue?vue&type=script&lang=js&"
export * from "./Quota.vue?vue&type=script&lang=js&"
import style0 from "./Quota.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Quota.vue?vue&type=style&index=1&id=34f98cb2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!/////node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f98cb2",
  null
  
)

export default component.exports